function Header() {
  return (
    <div className="w-full flex flex-col items-center justify-end">
      <h1 className="text-custom_black">درباره من</h1>
      <p className="text-sm sm:text-base xl:font-extralight text-custom_pink">
        من چه کسی هستم و در چه چیزهایی مهارت دارم.
      </p>
    </div>
  );
}

export default Header;